import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const getSessionId = () => {
  let sid = sessionStorage.getItem('wing_visit_sid');
  if (!sid) {
    sid = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem('wing_visit_sid', sid);
  }
  return sid;
};

const VisitTracker = () => {
  const location = useLocation();
  const firstHit = useRef(true);

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/admin')) return;
    const now = Date.now();
    const last = window.__wingLastTrack || {};
    if (last.path === path && now - last.ts < 2000) return;
    window.__wingLastTrack = { path, ts: now };
    const payload = {
      path,
      referrer: firstHit.current ? (document.referrer || null) : null,
      session_id: getSessionId(),
    };
    firstHit.current = false;
    axios.post(`${BACKEND_URL}/api/analytics/track`, payload).catch(() => {});
  }, [location.pathname]);

  return null;
};

export default VisitTracker;
